import { Suspense, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import useUserRoles from "hooks/use-user-roles.hook";
import { lazyWithRetry } from "utils/lazy-with-retry.util";

import {
  SOURCE_VIEW_PARAM,
  SourceViewerView,
  decodeView
} from "./source-record.util";

// Keeps the reload rung: this panel has no ErrorBoundary of its own, so a
// failed retry would otherwise escalate to the route error screen rather than
// self-heal (ENG-1868).
const SourceViewerPanel = lazyWithRetry(
  () => import("./source-viewer-panel.component"),
  "source-viewer-panel"
);

function RestoredSourceViewer({ view }: { view: SourceViewerView }) {
  const [open, setOpen] = useState(true);
  return open ? (
    <Suspense fallback={null}>
      <SourceViewerPanel
        open
        onClose={() => setOpen(false)}
        initialView={view}
      />
    </Suspense>
  ) : null;
}

/** Restore once per navigation, independently of paginated or virtualized rows. */
export default function SourceViewerDeepLink() {
  const { isSunoAdmin } = useUserRoles();
  const location = useLocation();
  const view = useMemo(
    () =>
      decodeView(new URLSearchParams(location.search).get(SOURCE_VIEW_PARAM)),
    [location.search]
  );

  return isSunoAdmin && view ? (
    <RestoredSourceViewer key={location.key} view={view} />
  ) : null;
}
